import { ReactNode } from 'react'

import { Box, BoxProps } from './Box'

export type RowProps = BoxProps & {
  children?: ReactNode
  reverse?: boolean
}

/**
 * @deprecated use <Div /> instead
 */
export const Row = (props: RowProps) => {
  return (
    <Box flexDirection={props.reverse ? 'row-reverse' : 'row'} {...props}>
      {props.children}
    </Box>
  )
}
